import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05a34f53"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nickname-edit-pc"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-close"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "修改昵称", -1));
const _hoisted_6 = {
  class: "pre-box"
};
const _hoisted_7 = {
  class: "pre-nickname"
};
const _hoisted_8 = {
  key: 0,
  class: "red"
};
const _hoisted_9 = {
  key: 1,
  class: "blue"
};
const _hoisted_10 = {
  class: "edit-box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新昵称：", -1));
const _hoisted_12 = {
  class: "buttons"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "popup-overlay",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.close && $setup.close(...args))
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "button-close",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, _hoisted_4), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, "当前昵称：" + _toDisplayString($setup.userInfo.nickname), 1), !$setup.freeChangeNickname ? (_openBlock(), _createElementBlock("div", _hoisted_8, "修改需要消耗2000福米")) : (_openBlock(), _createElementBlock("div", _hoisted_9, "本次改名免费"))]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _withDirectives(_createElementVNode("input", {
    type: "text",
    maxlength: "8",
    placeholder: "请输入2～8个中文字符",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.nickname = $event)
  }, null, 512), [[_vModelText, $setup.nickname]])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
    class: "save",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.saveSettings && $setup.saveSettings(...args))
  }, "保存"), _createElementVNode("button", {
    class: "cancel",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.close && $setup.close(...args))
  }, "取消")])])]);
}